import React, { useState, useEffect } from 'react';
import styles from './Nav.module.css';
import logoImage from '../../assets/LogoWhite.png';
import { showToast } from '../../utils/toast';
import PrimaryButton from '../Buttons/PrimaryButton/PrimaryButton';

function Nav() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 50;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [scrolled]);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [menuOpen]);

  const handlePreorderClick = (e) => {
    e.preventDefault();
    showToast.comingSoon();
  };

  const handleAirdropClick = (e) => {
    e.preventDefault();
    showToast.comingSoon();
  };

  return (
    <nav className={`${styles.nav} ${scrolled ? styles.scrolled : ''}`}>
      <div className={styles.container}>
        <h1 className={styles.gradientText}>RAYVO</h1>

        <div className={styles.desktopMenu}>
          <ul className={styles.menuItems}>
            <li><a href="https://rayvo.gitbook.io/rayvo" target="_blank" rel="noopener noreferrer">Docs</a></li>
            <li><a href="#" onClick={handleAirdropClick}>Airdrop</a></li>
          </ul>
          <PrimaryButton onClick={handlePreorderClick}>
            Preorder
          </PrimaryButton>
        </div>

        <div className={styles.burgerMenu} onClick={toggleMenu}>
          <div className={`${styles.burgerBar} ${menuOpen ? styles.open : ''}`}></div>
          <div className={`${styles.burgerBar} ${menuOpen ? styles.open : ''}`}></div>
          <div className={`${styles.burgerBar} ${menuOpen ? styles.open : ''}`}></div>
        </div>

        <div className={`${styles.mobileMenu} ${menuOpen ? styles.open : ''}`}>
          <ul className={styles.mobileMenuItems}>
            <li><a href="https://rayvo.gitbook.io/rayvo" target="_blank" rel="noopener noreferrer" onClick={toggleMenu}>Docs</a></li>
            <li>
              <a 
                href="#" 
                onClick={(e) => {
                  toggleMenu();
                  handleAirdropClick(e);
                }}
              >
                Airdrop
              </a>
            </li>
          </ul>
          <PrimaryButton 
            onClick={(e) => {
              toggleMenu();
              handlePreorderClick(e);
            }}
            className={styles.mobileLaunchButton}
          >
            Preorder
          </PrimaryButton>
        </div>
      </div>
    </nav>
  );
}

export default Nav;